<!-- 发起弹窗 -->
<template>
  <div>
    <el-dialog
      :title="$t('text.payinCredit')"
      :visible="isShowCreditDialog"
      width="30%"
      :close-on-click-modal="false"
      @open="handleDialogOpen"
      @close="handleDialogClose"
    >
      <el-form ref="form" :model="form" :rules="rules" label-width="170px">
        <el-form-item :label="$t('text.creditAvailableAmount')" prop="availableAmount">
          <el-input
              size="small"
              type="text"
              v-model="availableAmount"
              disabled
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('text.creditGrantedAmount')" prop="grantedAmount">
          <el-input
              size="small"
              type="text"
              v-model="grantedAmount"
              disabled
          ></el-input>
        </el-form-item>

        <el-form-item :label="$t('text.creditAmount')" prop="amount">
          <el-input
            size="small"
            type="text"
            v-model="form.amount"
            :placeholder="$t('message.inputCreditAmount')"
          ></el-input>
        </el-form-item>
        <el-form-item :label="$t('text.remark')" prop="remark">
          <el-input
            size="small"
            type="textarea"
            v-model="form.remark"
            :placeholder="$t('message.inputRemark')"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="handleDialogClose">{{ $t('text.cancel') }}</el-button>
        <el-button type="primary" @click="submit">{{ $t('text.confirm') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  props: {
    isShowCreditDialog: {
      type: Boolean,
      default: false
    },availableAmount: {
      type: Number | String,
      default: 0
    },grantedAmount: {
      type: Number | String,
      default: 0
    }
  },
  data() {
    return {
      form: {
        availableAmount: "",
        grantedAmount: "",
        amount: "",
        remark: ""
      },
      rules: {
        amount: [
          { required: true, validator: this.validateAmount, trigger: "blur" }
        ]
      }
    };
  },
  methods: {
    handleDialogOpen() {
      this.form.availableAmount = this.availableAmount;
      this.form.grantedAmount = this.grantedAmount;
    },
    handleDialogClose() {
      this.$refs["form"].resetFields();
      this.form = {
        amount: "",
        paymentAccount: "",
        collectAccount: "",
        remark: ""
      };
      this.$emit("update:isShowCreditDialog", false);
    },
    submit() {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          const params = {
            ...this.form
          };
          this.$axios
            .post("/creditApplicationRecord/addCreditApplicationRecord", params)
            .then((res) => {
              if (res.code === 200) {
                this.$notify({
                  title: this.$t('text.prompt'),
                  message: res.msg,
                  type: "success"
                });
                this.$emit("update:isShowCreditDialog", false);
                this.$bus.$emit("refresh"); //通知刷新
              } else {
                this.$notify.error({
                  title: this.$t('text.prompt'),
                  message: res.msg
                });
              }
            });
        }
      });
    },
    validateAmount(rule, value, callback) {
      var submitAmount = parseFloat(value);
      if (isNaN(submitAmount) || submitAmount <= 0) {
        callback(new Error(this.$t('message.numericError')));
      } else {
        if (submitAmount > this.availableAmount){
          callback(new Error(this.$t('message.invalidCreditAmount')));
        } else {
          callback();
        }
      }
    }
  }
};
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__header {
  border-bottom: 1px solid #e4e7ed;
}
</style>
